<template>
    <svg class="shape-content" viewBox="0 0 1440 737">
        <path
            d="M-254.098 684.341C-272.602 621.724 -224.355 597.258 -184.587 585.503L191.097 474.487C230.861 462.735 284.663 457.051 303.161 519.663C321.667 582.277 273.421 606.746 233.651 618.499L-142.031 729.517C-181.795 741.267 -235.595 746.951 -254.098 684.341Z"
            fill="var(--joy-color-primary-30)"
            class="shape-content__sm"
        />
        <path
            d="M-313.121 503.044C-323.114 384.575 -228.083 358.664 -152.839 352.319L557.952 292.379C633.184 286.038 731.218 295.674 741.21 414.126C751.201 532.595 656.167 558.508 580.924 564.85L-129.864 624.789C-205.099 631.133 -303.134 621.499 -313.121 503.044Z"
            fill="var(--joy-color-neutral-20)"
            class="shape-content__md"
        />
        <path
            d="M-250.591 222.745C-240.6 17.5278 -71.8811 -5.10245 58.4624 1.24575L1289.72 61.2377C1420.04 67.5869 1585.76 106.524 1575.77 311.717C1565.77 516.938 1397.06 539.571 1266.72 533.215L35.4605 473.229C-94.8703 466.876 -260.592 427.941 -250.591 222.745Z"
            fill="var(--joy-color-primary-50)"
            class="shape-content__lg"
        />
    </svg>
</template>

<style lang="scss">
    .shape-content {
        overflow: visible;
        width: 100%;

        &__sm {
            fill: var(--joy-color-primary-30);
        }

        &__md {
            fill: var(--joy-color-neutral-20);
        }

        &__lg {
            fill: var(--joy-color-primary-50);
        }
    }
</style>
